import pusher from '@/store/creative/push/index.js'
import detail from '@/store/creative/detail/index.ts'
import delivery from './delivery.ts'

const creative = {
  namespaced: true,
  modules: {
    pusher,
    detail,
    delivery,
  },
}

export default creative
